'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    DropdownSelect: {
        displayName: 'DropdownSelect'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/DropdownSelect/DropdownSelect.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var DropdownSelect = _wrapComponent('DropdownSelect')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(DropdownSelect, _Component);

    function DropdownSelect(props) {
        (0, _classCallCheck3.default)(this, DropdownSelect);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DropdownSelect.__proto__ || (0, _getPrototypeOf2.default)(DropdownSelect)).call(this, props));

        _this.handleBlur = function () {
            _this.setState({ open: false });
        };

        _this.handleChange = function (id) {
            _this.setState({ open: false });
            _this.props.onChange(id);
        };

        _this.handleClick = function () {
            _this.setState({ open: !_this.state.open });
            if (_this.props.onClick) {
                _this.props.onClick();
            }
        };

        _this.state = {
            open: false
        };
        return _this;
    }

    (0, _createClass3.default)(DropdownSelect, [{
        key: 'render',
        value: function render() {

            var View = _helpers.ThemeHelper.getViewForComponent('DropdownSelect');

            var _props = this.props,
                title = _props.title,
                items = _props.items,
                selected = _props.selected,
                textField = _props.textField,
                idField = _props.idField;


            return _react3.default.createElement(View, {
                title: title,
                items: items,
                selected: selected,
                textField: textField,
                idField: idField,
                open: this.state.open,
                handleBlur: this.handleBlur,
                handleChange: this.handleChange,
                handleClick: this.handleClick
            });
        }
    }]);
    return DropdownSelect;
}(_react2.Component), _class.propTypes = {
    onChange: _react2.PropTypes.func.isRequired,
    title: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.number]).isRequired,
    items: _react2.PropTypes.array.isRequired
}, _temp));

exports.default = DropdownSelect;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DropdownSelect/DropdownSelect.jsx
// module id = 1655
// module chunks = 0